import { IconContext, type IconProps } from "@phosphor-icons/react";
import { useMemo, type PropsWithChildren } from "react";

import { getDir } from "@/hooks/useLocaleInfo";
import type { Locale } from "@/utils/locale";

type Props = PropsWithChildren<{
  locale: Locale;
}>;

export function IconContextProvider({ locale, children }: Props) {
  const contextValue = useMemo<IconProps>(
    () => ({
      "aria-hidden": true,
      mirrored: getDir(locale) === "rtl",
    }),
    [locale],
  );

  return <IconContext value={contextValue}>{children}</IconContext>;
}
